/* Boonsoir 2.0 — Herfstpakketten countdown. Ticks on the second boundary; digits are aria-hidden,
   screen readers get one fixed deadline sentence from the markup. */
(() => {
  const pad = (n) => String(n).padStart(2, '0');

  function start(el) {
    if (el._pk) return;
    el._pk = true;
    const deadline = Date.parse(el.dataset.deadline);
    if (Number.isNaN(deadline)) return;
    const units = {};
    el.querySelectorAll('[data-pk-unit]').forEach((u) => { units[u.dataset.pkUnit] = u; });
    const dayLabel = units.d && units.d.nextElementSibling;
    let timer = null;

    // Digits roll: only the characters that change slide up and out, the new one comes in from below.
    const set = (key, value) => {
      const u = units[key];
      if (!u) return;
      const fx = window.BoonsoirFX;
      if (fx && fx.roll) { fx.roll(u, value); return; }
      if (u.textContent !== value) u.textContent = value;
    };
    const render = () => {
      let left = Math.max(0, Math.floor((deadline - Date.now()) / 1000));
      const d = Math.floor(left / 86400); left -= d * 86400;
      const h = Math.floor(left / 3600); left -= h * 3600;
      const m = Math.floor(left / 60);
      const s = left - m * 60;
      set('d', String(d));
      set('h', pad(h));
      set('m', pad(m));
      set('s', pad(s));
      if (dayLabel) dayLabel.textContent = d === 1 ? 'dag' : 'dagen';
      return deadline - Date.now();
    };
    const tick = () => {
      const remaining = render();
      if (remaining <= 0) { el.classList.add('is-closed'); return; }
      timer = setTimeout(tick, 1000 - (Date.now() % 1000) + 5);
    };
    tick();
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) { clearTimeout(timer); } else { clearTimeout(timer); tick(); }
    });
  }

  const init = (scope = document) => scope.querySelectorAll('[data-pk-timer]').forEach(start);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
